import React, { FC } from "react";
import styled from "styled-components";
import BlockImage from '../../images/block_image.png';
import Button from "./Button";
import { useDispatch } from "react-redux";
import { setBlock } from "../../modules";

const BlockBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background-color: rgba(237, 234, 231, 1);
    backdrop-filter: blur(4px);

    width: 100%;
    height: 100vh;

    z-index: 100;

    position: fixed;

    & p {
        color: black;
    }

    & > button {
        text-align: center;
        justify-content: center;
        align-items: center;
    }
`;

const Block:FC = () => {
    const dispatch = useDispatch();
    const onReturn = () => {
        dispatch(setBlock(false));
    }
    return (
        <BlockBox>
            <img src={BlockImage} width="400px" height="auto" alt="shy develop"/>
            <p>부끄러워 하는 개발자 전용 기능</p>
            <Button onClick={onReturn}>돌아가기</Button>
        </BlockBox>
    );
};

export default Block;